import { useState } from "react";

function SuffixChips({ suffixes }) {
  if (!suffixes || suffixes.length === 0) return null;
  return (
    <span className="apiChips">
      <span className="apiSrOnly">{`Suffixes: ${suffixes.join(" ")}`}</span>
      {suffixes.map((s) => (
        <span className="apiChip" key={s} aria-hidden="true">{s}</span>
      ))}
    </span>
  );
}

/**
 * Query-parameter table for one list operation. Shows `initiallyShown` rows; the rest sit
 * behind a disclosure button so long tables (datasets has 17) don't swamp the page.
 */
export function ApiFilterTable({ filters, initiallyShown = 8, idPrefix }) {
  const [expanded, setExpanded] = useState(false);
  const tableId = `${idPrefix}-filters`;

  if (!filters || filters.length === 0) {
    return <p className="apiSmall apiSmallMeta">No filters. The list is short enough to read whole.</p>;
  }

  const hidden = Math.max(filters.length - initiallyShown, 0);
  const rows = expanded ? filters : filters.slice(0, initiallyShown);

  return (
    <>
      <table className="apiTable" id={tableId}>
        <thead>
          <tr>
            <th className="apiTableColName">Filter</th>
            <th className="apiTableColType">Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((f) => (
            <tr key={f.name}>
              <td>
                <span className="apiParamName">{f.name}</span>
                <SuffixChips suffixes={f.suffixes} />
              </td>
              <td><span className="apiParamType">{f.type}</span></td>
              <td>{f.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {hidden > 0 && (
        <button
          type="button"
          className="apiDisclosure"
          aria-expanded={expanded}
          aria-controls={tableId}
          onClick={() => setExpanded((v) => !v)}
        >
          <span aria-hidden="true">{expanded ? "−" : "+"}</span>
          {expanded ? "Show fewer filters" : `Show ${hidden} more filters`}
        </button>
      )}
    </>
  );
}
